/* eslint-disable sort-keys */
export const urls: Record<
  'de',
  Record<string, '/l/de/de' | `/l/de/de/${string}`>
> = {
  de: {
    // Home
    '': '/l/de/de/home',

    // Alumni
    alumni: '/l/de/de/alumni',

    // B2B
    unternehmen: '/l/de/de/b2b',
    'unternehmen/kontakt': '/l/de/de/b2b/apply',

    // Blog
    blog: '/l/de/de/blog',

    // Campus
    berlin: '/l/de/de/campus/ber',
    remote: '/l/de/de/campus/rmt',

    // Career
    'karriere-services': '/l/de/de/career',

    // Courses
    webentwicklung: '/l/de/de/course/wd',
    'data-analytics': '/l/de/de/course/da',
    'ux-ui-design': '/l/de/de/course/ux',
    cybersecurity: '/l/de/de/course/cy',

    // FAQ
    faq: '/l/de/de/faq',

    // Financing Options
    finanzierung: '/l/de/de/financing',

    // Forms
    bewerben: '/l/de/de/apply',
    bewerben2: '/l/de/de/full-apply',
    kontakt: '/l/de/de/contact',
    'finanzierung-form': '/l/de/de/financing-form',
    danke: '/l/de/de/thank-you',

    // Quiz
    quiz: '/l/de/de/quiz',
    'kunstliche-intelligenz/match': '/l/de/de/quiz-match/ai',
    'cybersecurity/match': '/l/de/de/quiz-match/cy',
    'data-analytics/match': '/l/de/de/quiz-match/da',
    'devops-cloud-computing/match': '/l/de/de/quiz-match/dv',
    'digital-marketing/match': '/l/de/de/quiz-match/mk',
    'data-science-machine-learning/match': '/l/de/de/quiz-match/ml',
    'ux-ui-design/match': '/l/de/de/quiz-match/ux',
    'webentwicklung/match': '/l/de/de/quiz-match/wd',

    // Syllabus Forms
    'ki-consulting-integration/syllabus': '/l/de/de/syllabus/ac',
    'kunstliche-intelligenz/syllabus': '/l/de/de/syllabus/ai',
    'cloud-engineer/syllabus': '/l/de/de/syllabus/ce',
    'cybersecurity/syllabus': '/l/de/de/syllabus/cy',
    'data-analytics/syllabus': '/l/de/de/syllabus/da',
    'data-engineering/syllabus': '/l/de/de/syllabus/de',
    'devops-cloud-computing/syllabus': '/l/de/de/syllabus/dv',
    'digital-marketing/syllabus': '/l/de/de/syllabus/mk',
    'data-science-machine-learning/syllabus': '/l/de/de/syllabus/ml',
    'ki-product-manager/syllabus': '/l/de/de/syllabus/pm',
    'ux-ui-design/syllabus': '/l/de/de/syllabus/ux',
    'webentwicklung/syllabus': '/l/de/de/syllabus/wd',

    // PDP
    'ki-consulting-integration/remote': '/l/de/de/pdp/ac/rmt',
    'kunstliche-intelligenz/berlin': '/l/de/de/pdp/ai/ber',
    'kunstliche-intelligenz/remote': '/l/de/de/pdp/ai/rmt',
    'cloud-engineer/remote': '/l/de/de/pdp/ce/rmt',
    'cybersecurity/berlin': '/l/de/de/pdp/cy/ber',
    'cybersecurity/remote': '/l/de/de/pdp/cy/rmt',
    'data-analytics/berlin': '/l/de/de/pdp/da/ber',
    'data-analytics/remote': '/l/de/de/pdp/da/rmt',
    'data-engineering/remote': '/l/de/de/pdp/de/rmt',
    'devops-cloud-computing/remote': '/l/de/de/pdp/dv/rmt',
    'digital-marketing/remote': '/l/de/de/pdp/mk/rmt',
    'data-science-machine-learning/remote': '/l/de/de/pdp/ml/rmt',
    'ki-product-manager/remote': '/l/de/de/pdp/pm/rmt',
    'ux-ui-design/berlin': '/l/de/de/pdp/ux/ber',
    'ux-ui-design/remote': '/l/de/de/pdp/ux/rmt',
  },
};
/* eslint-enable sort-keys */
